import { render, staticRenderFns } from "./effective-fee-information.vue?vue&type=template&id=cc0f7106&"
import script from "./effective-fee-information.vue?vue&type=script&lang=ts&"
export * from "./effective-fee-information.vue?vue&type=script&lang=ts&"
import style0 from "./effective-fee-information.vue?vue&type=style&index=0&id=cc0f7106&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports